import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SignaturePad from '../claims/SignaturePad';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: (signatureData: string) => void;
  loading?: boolean;
};

/**
 * Clinical record sign-off. Uses the shared SignaturePad (pointer events, so
 * touch and pen work on tablets; JPEG at CSS size) — the old mouse-only canvas
 * could not be signed on an iPad.
 */
export default function SignatureDialog({
  open,
  onClose,
  onConfirm,
  loading = false,
}: Props) {
  const [signature, setSignature] = useState('');

  useEffect(() => {
    if (!open) setSignature('');
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Sign Off Clinical Record</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <SignaturePad
            label="Signature"
            height={200}
            onChange={setSignature}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <LoadingButton
          onClick={() => onConfirm(signature)}
          variant="contained"
          loading={loading}
          disabled={!signature}
        >
          Sign & Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
